// extracted by mini-css-extract-plugin
export default {"card":"card-agMf7","label_wrap":"label_wrap-cVRbR","label_text":"label_text-hHWbU","flag":"flag-r0UCs","liveFlag":"liveFlag-aC3iH"};